export default __webpack_public_path__ + "static/media/Juggling.cca16018.png";